export const MainWrapper = 'flex flex-col w-full'

export const Headline = 'mb-4 text-black font-Roboto'

export const ListWrapper =
  'flex flex-col font-Roboto text-14 leading-24 tracking-0'

export const ListItem = ''

export const Link = 'mt-6 w-moz-fit w-fit'
